import { remCalc } from './remCalc';

export const cssWidthAndHeight = (size: number, height?: number) => ({
  width: remCalc(size),
  height: remCalc(height ?? size),
});
